<template>
	<div id="app">
		<img alt="Vue logo" src="./assets/logo.png" />
		<Tile
			v-for="(t, index) of tiles"
			:key="index"
			:number="t.number"
			:isAlive="t.isAlive"
			:isSelected="t.isSelected"
			@onSelect="selectTile(index)"
		></Tile>
	</div>
</template>

<script>
import Tile from './components/Tile.vue';

export default {
	name: 'app',
	components: {
		Tile
	},
	data() {
		const tiles = [];

		for (let i = 1; i <= 5; ++i) {
			tiles.push(
				{ number: i, isAlive: true, isSelected: false },
				{ number: i, isAlive: true, isSelected: false }
			);
		}
		shuffle(tiles);

		return {
			tiles,
			oldSelect: null,
			newSelect: null
		};
	},
	methods: {
		selectTile(index) {
			if (
				!this.tiles[index].isAlive ||
				this.tiles[index].isSelected ||
				this.newSelect
			) {
				return;
			}
			if (this.oldSelect === null) {
				this.tiles[index].isSelected = true;
				this.oldSelect = index;
				return;
			}
			this.tiles[index].isSelected = true;
			this.newSelect = index;
			setTimeout(() => {
				if (
					this.tiles[this.newSelect].number ===
					this.tiles[this.oldSelect].number
				) {
					this.tiles[this.oldSelect].isAlive = false;
					this.tiles[this.newSelect].isAlive = false;
					this.tiles[this.newSelect].isSelected = false;
				}
				this.tiles[this.oldSelect].isSelected = false;
				this.oldSelect = this.newSelect;
				this.newSelect = null;
			}, 1000);
		}
	}
};

function shuffle(array) {
	for (let i = array.length - 1; i > 0; --i) {
		const j = Math.floor(Math.random() * (i + 1));
		[array[i], array[j]] = [array[j], array[i]];
	}
}
</script>

<style>
#app {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
	margin-top: 60px;
}
</style>
